export default defineNuxtPlugin((nuxtApp) => {
    // access cookie for auth
    const cookie = useCookie('<cookie_name>')
    nuxtApp.hook('apollo:auth', ({ client, token }) => {
      // `client` can be used to differentiate logic on a per client basis.
      // apply apollo client token
      token.value = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjQzNzEsInR5cGUiOiJ1c2VyIiwibW9kZSI6ImFwaSIsImV4cCI6MjAyMzY5NDg2NiwiaXNzIjoiRGlnaWZvcm1hIn0.CV3dpqCYdqCWhVrpDDpt2mwEcHJiVArEBBZzgIE1i28'
    })
  })